import { css } from 'styled-components';
export const flexCenter = css `
    display: flex;
    align-items: center;
    justify-content: center;
`;
export const flexCenterX = css `
    display: flex;
    justify-content: center;
`;
export const flexCenterY = css `
    display: flex;
    align-items: center;
`;
//# sourceMappingURL=mixins.js.map